// src/ErrorBoundary.js
import React from 'react';
import { notification } from 'antd';
import { withTranslation } from 'react-i18next';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isScenarioEditorError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if error is from scenario-designer
    const isScenarioEditorError = error?.stack?.includes('scenario-designer');
    return { hasError: true, isScenarioEditorError };
  }

  componentDidCatch(error, errorInfo) {
    console.log('componentDidCatch ERROR');

    // Check if this is a scenario editor error
    const isScenarioEditorError = error?.stack?.includes('scenario-designer');

    if (isScenarioEditorError) {
      // For scenario editor errors, just log - don't show global notification
      console.error('Scenario editor error caught at root:', error);
      // Don't show notification, let the scenario editor handle it
    } else {
      // For other errors, show the notification
      notification.error({
        message: (
          <p>
            {this.props.t("errors.contact_administrator")}
          </p>
        ),
      });
    }
  }

  render() {
    if (this.state.hasError && !this.state.isScenarioEditorError) {
      // Only hide the app for non-scenario-editor errors
      return null;
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);